import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './WarningMessage.styles';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';

interface Props {
  message: string;
}

export const WarningMessage: FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <S.Warning data-testid={AdPageTestIds.categoryWarning}>
      <IconBox $filename="warning-3.svg" $width={30} $height={30} />
      <Typography.Body
        $variant="4"
        data-testid={AdPageTestIds.categoryWarningText}
      >
        <S.WarningTitle $variant="4" as="span">
          {t('common.attention')}{' '}
        </S.WarningTitle>
        {message}
      </Typography.Body>
    </S.Warning>
  );
};
